var React = require('react');

function Txt (props) {
    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("path",{"d":"M29.3,8.8V0.2H6v46.6c0,1.6,1.3,2.9,2.9,2.9h35v-35h-8.7C32,14.8,29.3,12.2,29.3,8.8z M19.3,25.6h-3.4v9.5h-2.3v-9.5h-3.4\n\t\tv-1.9h9.1V25.6z M27.5,35.2l-2.5-4l-2.5,4h-2.8l3.9-6L20,23.7h2.7l2.3,3.7l2.2-3.7H30l-3.6,5.6l3.9,5.9H27.5z M39.8,25.6h-3.4v9.5\n\t\th-2.3v-9.5h-3.4v-1.9h9.1V25.6z","key":0}),React.createElement("path",{"d":"M34.9,12H44L32.3,0.2V9C32.3,10.5,33.4,12,34.9,12z","key":1})]));
}

Txt.defaultProps = {"version":"1.1","id":"Warstwa_1","x":"0px","y":"0px","viewBox":"0 0 50 50","style":{"enableBackground":"new 0 0 50 50"},"xmlSpace":"preserve"};

module.exports = Txt;

Txt.default = Txt;
